import React, { useEffect } from "react";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import { Helmet } from "react-helmet";

const SAPSupport = () => {
  // Optional: Disable right-click
  useEffect(() => {
    const disableRightClick = (e) => e.preventDefault();
    document.addEventListener("contextmenu", disableRightClick);
    return () => document.removeEventListener("contextmenu", disableRightClick);
  }, []);

  return (
    <>
      <Helmet>
        <title>Complete SAP Enterprise Support Services | Dhanam</title>
        <meta
          name="description"
          content="Dhanam offers full-spectrum SAP Enterprise Support Services including FICO, SD, MM, ABAP, security, testing, integrations, and 24/7 support models."
        />
      </Helmet>

      <NavBar />

      {/* Hero Section */}
      <div className="about-hero text-white text-center py-5">
        <div className="container">
          <h1 className="display-5 fw-bold">Complete SAP Enterprise Support Services</h1>
          <p className="lead mt-3">
            Seamless SAP Operations. Optimized Performance. Strategic Value.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-5">
        {/* First Row */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <h3 className="fw-bold mb-4">What We Offer</h3>
            <ul className="custom-list">
              <li>
                <strong>SAP Functional Support</strong>
                <ul>
                  <li>✔ FICO: Real-time support for financial operations.</li>
                  <li>✔ SD: Optimizing sales and billing workflows.</li>
                  <li>✔ MM: Streamlined procurement & inventory.</li>
                  <li>✔ Support for HCM, PP, and more.</li>
                </ul>
              </li>
              <li>
                <strong>SAP ABAP Development</strong>
                <ul>
                  <li>✔ Custom reports, SmartForms, tuning.</li>
                </ul>
              </li>
              <li>
                <strong>SAP Testing Services</strong>
                <ul>
                  <li>✔ Functional, regression, integration testing.</li>
                </ul>
              </li>
              <li>
                <strong>SAP Security & Authorizations</strong>
                <ul>
                  <li>✔ Role-based access, GRC compliance.</li>
                </ul>
              </li>
              <li>
                <strong>SAP Basis & Technical Support</strong>
                <ul>
                  <li>✔ System patching, upgrades, performance tuning.</li>
                </ul>
              </li>
              <li>
                <strong>Third-Party Integration</strong>
                <ul>
                  <li>✔ APIs, IDocs, BAPIs, PI/PO integration.</li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="col-md-6 text-center">
            <img
              src="https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg"
              alt="SAP Support Services"
              className="img-fluid rounded shadow"
            />
          </div>
        </div>

        {/* Divider */}
        <hr className="my-5" />

        {/* Second Row */}
        <div className="row align-items-center">
          <div className="col-md-6 order-md-2 text-center">
            <img
              src="https://images.pexels.com/photos/1181352/pexels-photo-1181352.jpeg"
              alt="SAP Support Models"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6 order-md-1">
            <h3 className="fw-bold mb-4">Support Models We Offer</h3>
            <ul className="custom-list">
              <li>✔ Onsite, Offshore, and Hybrid Models</li>
              <li>✔ Dedicated or Shared Support Teams</li>
              <li>✔ 24/7 SLA-Based Monitoring & Support</li>
            </ul>

            <h3 className="fw-bold mt-4 mb-3">Why Choose Dhanam?</h3>
            <ul className="custom-list">
              <li>✔ Certified SAP consultants across modules</li>
              <li>✔ 25+ years of enterprise IT experience</li>
              <li>✔ Industry-specific SAP knowledge</li>
              <li>✔ Flexible support models and pricing</li>
              <li>✔ Proven delivery frameworks</li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-5">
          <h4 className="fw-bold">Empower your enterprise with reliable, scalable SAP support.</h4>
          <p>
            Partner with Dhanam Information Systems to keep your SAP systems running at peak performance — every day.
          </p>
        </div>
      </div>

      <Footer />

      {/* Scoped Styling */}
      <style jsx>{`
        .about-hero {
          background-color: rgb(11, 22, 63);
        }

        .custom-list {
          list-style: none;
          padding-left: 0;
        }

        .custom-list > li {
          margin-bottom: 12px;
        }

        .custom-list ul {
          list-style: none;
          margin-top: 5px;
          padding-left: 1rem;
        }

        .custom-list ul li {
          position: relative;
          padding-left: 25px;
          margin-bottom: 8px;
        }

        .custom-list ul li::before {
          position: absolute;
          left: 0;
          color: green;
          font-weight: bold;
        }

        @media (max-width: 768px) {
          h1.display-5 {
            font-size: 2rem;
          }
          h3 {
            font-size: 1.25rem;
          }
        }
      `}</style>
    </>
  );
};

export default SAPSupport;
